import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { md } from '@/utils/utils_html';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { useTranslation } from 'react-i18next';
import { TabSettingsWorkspaceWrapper } from '../_base/TabSettingsWorkspaceWrapper';
import { ESettingsWorkspaceTab } from '../ESettingsWorkspaceTab';
import { ButtonWorkspaceStopSharing } from './ButtonWorkspaceStopSharing';
import { WSSharedCollectionTable } from './table_shared_collections/WSSharedCollectionsTable';
import { WSSharedSearchTable } from './table_shared_search/WSSharedSearchTable';
import { WSSharedUserTasksTable } from './table_shared_user_tasks/WSSharedUserTasksTable';

export function TabSettingsWorkspaceSharedEntities() {
  const dispatch = use_dispatch();

  const { page_settings_workspace_current_tab } = use_slice_ui(['page_settings_workspace_current_tab']);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  /*
   * EFFECTS
   */

  //+deps: page_settings_workspace_current_tab
  use_effect(() => {
    if (current_workspace_user.is_sharing_permitted()) return;
    if (page_settings_workspace_current_tab != ESettingsWorkspaceTab.SHARED_ENTITIES) return;

    dispatch(
      LOCAL__ui_set_string({
        key: 'page_settings_workspace_current_tab',
        value: ESettingsWorkspaceTab.GENERAL,
        valid_values: Object.values(ESettingsWorkspaceTab),
      }),
    );
  }, [current_workspace_user, page_settings_workspace_current_tab]);

  /*
   * HTML
   */

  if (!current_workspace_user.is_sharing_permitted()) return <></>;

  return (
    <TabSettingsWorkspaceWrapper type={ESettingsWorkspaceTab.SHARED_ENTITIES}>
      <div className="flex flex-col justify-start items-start mt-2 gap-3  text-page-foreground">
        <span className="text-xl">{t(i18n_page_settings_workspace.tabs.shared_entities.title)}</span>

        <div className={`flex flex-wrap   items-center  ${md(' justify-between w-full gap-x-4 gap-y-4', ' justify-start w-[60rem] gap-10')}`}>
          <ButtonWorkspaceStopSharing />
        </div>

        {current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_USER_TASK_SHARE) && <WSSharedUserTasksTable />}
        {current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_SEARCH_SHARE) && <WSSharedSearchTable />}
        {current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_COLLECTION_SHARE) && <WSSharedCollectionTable />}
      </div>
    </TabSettingsWorkspaceWrapper>
  );
}
